function normalizeString(value) {
  return typeof value === 'string' ? value.trim() : value == null ? '' : String(value).trim()
}

export function resolveMemberPortalDisplayFirstName({ member = null, auth0User = null, fallback = 'Member' } = {}) {
  const memberFirstName = normalizeString(member?.first_name ?? member?.firstName)
  if (memberFirstName) return memberFirstName

  const memberPreferredName = normalizeString(member?.preferred_name ?? member?.preferredName)
  if (memberPreferredName) return memberPreferredName

  const givenName = normalizeString(auth0User?.given_name ?? auth0User?.first_name ?? auth0User?.firstName)
  if (givenName) return givenName

  const auth0Name = normalizeString(auth0User?.name)
  if (auth0Name) return auth0Name

  return normalizeString(fallback) || 'Member'
}

export default resolveMemberPortalDisplayFirstName
